module.exports = __webpack_public_path__ + "img/1440.ea671eb8.jpg";